module.exports = __webpack_public_path__ + "static/media/bg14.d9fa8f0d.jpg";